import {has} from '@malt/common';

const MAP_STYLE_OPTIONS = [
    {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [{visibility: 'off'}],
    },
    {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [{visibility: 'off'}],
    },
    {
        featureType: 'road',
        elementType: 'all',
        stylers: [{visibility: 'off'}],
    },
    {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{visibility: 'off'}],
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [{visibility: 'off'}],
    },
];

Hop.defineModule('freelancer-map', (root, param) => {
    let infowindow;
    let map;

    function listenToUserAction() {
        map.data.addListener('mousemove', showRegionTooltip);
    }

    function removeDiacritics(s) {
        const diacritics = [
            [/[\300-\306]/g, 'A'],
            [/[\340-\346]/g, 'a'],
            [/[\310-\313]/g, 'E'],
            [/[\350-\353]/g, 'e'],
            [/[\314-\317]/g, 'I'],
            [/[\354-\357]/g, 'i'],
            [/[\322-\330]/g, 'O'],
            [/[\362-\370]/g, 'o'],
            [/[\331-\334]/g, 'U'],
            [/[\371-\374]/g, 'u'],
            [/[\321]/g, 'N'],
            [/[\361]/g, 'n'],
            [/[\307]/g, 'C'],
            [/[\347]/g, 'c'],
        ];
        for (let i = 0; i < diacritics.length; i++) {
            s = s.replace(diacritics[i][0], diacritics[i][1]);
        }
        return s;
    }

    function normalizeAreaName(name) {
        if (!name) {
            return name;
        }

        return removeDiacritics(name.toLowerCase()).replace(/-/g, ' ');
    }

    function showRegionTooltip(event) {
        const name = event.feature.getProperty('nom');
        const normalizedName = normalizeAreaName(event.feature.getProperty('nom'));
        const areas = param.areas;
        const count = has(areas, normalizedName) ? areas[normalizedName].count : 0;

        const contentString = `<p class="ft-thin v-tac u-mb1">${name}</p><strong class="txt-huge">${count}</strong>`;
        if (infowindow) {
            infowindow.close();
        }

        infowindow = new google.maps.InfoWindow({
            content: contentString,
            position: event.latLng,
            disableAutoPan: true,
        });

        infowindow.open(map);
    }

    function initMap() {
        map = new google.maps.Map(document.getElementById('map-geojson'), {
            center: new google.maps.LatLng(46.5, 2.37359),
            zoom: 6,
            draggable: false,
            mapTypeControl: false,
            streetViewControl: false,
            disableDefaultUI: true,
            scrollwheel: false,
            mapTypeId: 'mystyle',
            backgroundColor: 'transparent',
        });

        map.mapTypes.set('mystyle', new google.maps.StyledMapType(MAP_STYLE_OPTIONS, {name: 'My Style'}));
        map.data.loadGeoJson(`https://cdn.malt.com/maps/${param.country}_${param.area}.geojson`);
    }

    function setFreelancerDistributionInRegionStyles() {
        map.data.setStyle((feature) => {
            const nom = feature.getProperty('nom');
            let fillColor = '#b3e5fc';

            if (has(param.areas, removeDiacritics(nom.toLowerCase()).replace(/-/g, ' '))) {
                const area = param.areas[removeDiacritics(nom.toLowerCase()).replace(/-/g, ' ')];
                fillColor = area.color;
            }

            return {
                fillColor: fillColor,
                fillOpacity: 1,
                strokeColor: 'white',
                strokeOpacity: 1,
                strokeWeight: 1,
            };
        });
    }

    function init() {
        initMap();
        setFreelancerDistributionInRegionStyles();
        listenToUserAction();
        root.classList.add('loaded');
    }

    window.addEventListener('load', init, {once: true});
});
